import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigUser } from '../../../core/configs/user.config';

import {
  CustomerService,
  ValidateInputService,
  messageErrorCustomer,
  AuthService,
  Constants,
  isMobile,
  Address,
  CustomerOP,
  Customer,
  patternDocumentType,
  getMaxLegthCellNumber,
  ConfigurationService
} from '../../../core';
import { SnackbarService } from '../snackbar/snackbar.service';
import { CustomerInput } from '../../../sale/model';
import { Country, PROMART_ECUADOR_CODE } from '../../../core/configs/company.config';

@Component({
  standalone: false,
  selector: 'app-customer-information',
  templateUrl: './customer-information.component.html',
  styleUrls: ['./customer-information.component.scss']
})
export class CustomerInformationComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * Envia la validación del formulario
   */
  @Output() isValidForm = new EventEmitter<boolean>();
  /**
   * Envia los datos del cliente
   */
  @Output() getCustomerData = new EventEmitter<CustomerOP>();
  /**
   * Si desea mostrar los datos adicionales del usuario
   */
  @Input() aditional: boolean;
  @Input() isClone = false;

  public isMobile = isMobile();
  public isActive = false;
  public pickPerson = false;
  public myform: FormGroup;
  public validation_messages;
  public document: any[];
  public idCustomer: number;
  private quotation = Constants.ConfigQuotation;
  public waysToPay: any[];
  public customersType: any[];
  loadState = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  private companyCode: any;
  private country: string;
  public currencyCode: string;
  public userPermiss: string[];
  public deferredPayment = false;
  public isDeferredPayment = true;
  numberInstallmentsOptions: any = [];


  public optionCreditConfig: any[] = [];
  public numberInstallmentsConfig: any = {};
  public showInputCredits = false;
 
  maxlengthCellNumber: number;
  quotationParentNumber: string;
  isHESACompany = false;
  constructor(
    public formBuilder: FormBuilder,
    public snackbarService: SnackbarService,
    public authService: AuthService,
    public validateService: ValidateInputService,
    private customerService: CustomerService,
    public configurationService: ConfigurationService
  ) {
    this.maxlengthCellNumber = getMaxLegthCellNumber();
    this.companyCode = this.authService.getCompanyCode();
    this.isHESACompany = this.companyCode === PROMART_ECUADOR_CODE;
    this.country = this.authService.getUser().country;
    this.document = Constants.Customer.DOCUMENT_TYPES.getProps();
    this.currencyCode = this.authService.getUser().currencyCode;
    this.userPermiss = this.authService.getUser().permissions;


    this.myform = formBuilder.group({
      documentType: Constants.Customer.DOCUMENT_TYPES.DNI,
      identityDocument: [null, [Validators.required, Validators.pattern(patternDocumentType(Constants.Customer.DOCUMENT_TYPES.DNI))]],
      name: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(this.maxlengthCellNumber)]],
      email: ['', [Validators.required, Validators.email]],
      documentAditional: [''],
      nameAditional: [''],
      addresses: [null],
      dataCurrent: [null],
      aditional: new FormGroup({
        expirationStatus: new FormControl('-'),
        availableCreditText: new FormControl('-'),
        availableCredit: new FormControl('-'),
        customerType: new FormControl('NATURAL_PERSON'),
        paymentMethod: new FormControl('CASH'),
        deferredPayment: new FormControl({ value: false, disabled: this.isDeferredPayment }),
        numberInstallments: new FormControl(),
        numberDeferredInstallments:new FormControl()
      }),
      companySalesEnabled: new FormControl({ value: false, disabled: true })
    });
    this.waysToPay = [];
    this.customersType = this.quotation.CUSTOMER_TYPES.getProps();
    this.validation_messages = messageErrorCustomer;
  }
  ngOnInit() {
    this.setCompanySalesEditable();
    this.configurationService.read('OPTION_CREDIT_CONFIG').subscribe(response => {
      if (response && response.length > 0) { 
        response.forEach(config => {
          if (config.configName === 'OPTION_CREDIT_CONFIG') {
            this.optionCreditConfig = (JSON.parse(config.configValue))
          } else if (config.configName === 'NUMBER_OF_PAYMENT_CONFIG') { 
            this.numberInstallmentsConfig = JSON.parse(config.configValue);
            this.generateNumberInstallmentsOptions();
          }
        })
      }
    });
    this.myform.controls['identityDocument']
      .valueChanges.subscribe(txtNumeroDocument => {
        this.loadState = false;
        if (txtNumeroDocument.length < this.getTypeNum().min
          && txtNumeroDocument.length >= this.getTypeNum().min - 1
          || !txtNumeroDocument.length) {
          this.clearForm();
        }
      });

    this.myform.valueChanges.subscribe(value => {
      if (this.myform.valid) {
        if (this.pickPerson) {
          if (this.myform.controls['documentAditional'].value !== '' &&
            this.myform.controls['nameAditional'].value !== '') {
            this.isValidForm.emit(true);
            this.getCustomerData.emit({ information: this.myform.getRawValue(), id: this.idCustomer });
          } else {
            this.isValidForm.emit(false);
          }
        } else {
          this.isValidForm.emit(true);
          this.getCustomerData.emit({ information: this.myform.getRawValue(), id: this.idCustomer });
        }
      } else {
        this.isValidForm.emit(false);
      }
    });
  }

  generateNumberInstallmentsOptions() {
    if (this.numberInstallmentsConfig.defaultValue) { 
      this.numberInstallmentsOptions.push({
        text: this.numberInstallmentsConfig.defaultValue.text,
        value: Number(this.numberInstallmentsConfig.defaultValue.value)
      });
    }
    for (let i = this.numberInstallmentsConfig.min; i <= this.numberInstallmentsConfig.max; i++) {
      this.numberInstallmentsOptions.push({
        text: i,
        value: Number(i)
      });
    }
  }

  get userHasCashOnDeliveryPermission(): boolean {
    return this.userPermiss.includes(ConfigUser.PERMISSIONS.CASH_ON_DELIVERY);
  }

  ngOnChanges() {
    this.setCompanySalesEditable();
    const userHasCashOnDeliveryPermission = this.userHasCashOnDeliveryPermission

    this.waysToPay = this.quotation.PAYMENT_TYPES_ENTERPRISE.getProps().filter(item => {
      if (userHasCashOnDeliveryPermission) {
        if (item.value === 'CASH_ON_DELIVERY') {
            item.cashondelivery = true;
        }
      }
      return ((this.aditional ? item.quotation : true) &&
        (!item.paymentByCompany || item.paymentByCompany.includes(this.companyCode))) ||
        (item.cashondelivery == true);
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onChangeSelectdocumentType(txtTypeDocument) {
    this.clearForm();
    this.myform.controls['identityDocument'].patchValue('');
    const valid = this.getTypeNum(txtTypeDocument);
    this.myform.controls['identityDocument']
      .setValidators([
        Validators.required,
        Validators.pattern(patternDocumentType(txtTypeDocument)),
        Validators.minLength(valid.min),
        Validators.maxLength(valid.max)
      ]);
    this.myform.controls['identityDocument'].updateValueAndValidity();
  }

  onChangeCheckbox(event) {
    this.pickPerson = event;
    if (this.pickPerson) {
      this.myform.controls['nameAditional'].setValidators([Validators.required, Validators.maxLength(255)]);
      this.myform.controls['documentAditional'].setValidators([Validators.required, Validators.maxLength(100)]);
    } else {
      this.myform.controls['nameAditional'].clearValidators();
      this.myform.controls['documentAditional'].clearValidators();
      this.myform.patchValue({
        nameAditional: '',
        documentAditional: ''
      });
    }
    this.myform.updateValueAndValidity();
  }

  getIdentityDocument(responseCustomer: CustomerInput, quotationParentNumber ? :   string) {
    this.enableForm();
    this.onChangeSelectdocumentType(responseCustomer.documentType);
    this.showInputCredits = responseCustomer.paymentMethod === this.quotation.PAYMENT_TYPES_ENTERPRISE.OH_CARD;
    this.quotationParentNumber = quotationParentNumber;
    this.myform.patchValue({
      documentType: responseCustomer.documentType,
      identityDocument: responseCustomer.documentNumber,
      aditional:
      {
        expirationStatus: '-',
        availableCredit: '-',
        availableCreditText: '-',
        customerType: responseCustomer.customerType,
        paymentMethod: responseCustomer.paymentMethod,
        numberDeferredInstallments: responseCustomer.numberDeferredInstallments,
        numberInstallments: Number(responseCustomer.numberInstallments),
      }
    });
  }

  onClickGetCustomer(control: string) {
    this.getCustomer(control).then();
  }

  // funcion que consulta los datos del cliente con el metodo getCustomer del service Customer
  getCustomer(control: string, loadCustomer?: CustomerInput, addresses?: Address[]): Promise<any> {
    return new Promise((resolve, reject) => {
      const documentType = this.myform.controls['documentType'].value;
      if (this.validDocumentType(control.length)) {
        this.loadState = true;
        this.customerService
          .queryCustomer(control, documentType)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(response => {
            const data: Customer = response;
            this.idCustomer = data ? data.id : null;
            this.setInformationFrom(data, loadCustomer, addresses, 'No existen clientes con los datos indicados.');
            this.isActive = true;
            this.setCompanySalesEditable();
            resolve(true);
          }, error => {
            /* if (loadCustomer) {
              this.setValueLoad(loadCustomer, addresses, loadCustomer);
            } */
            reject(false);
          });
      }
    });
  }

  validDocumentType(length: number): boolean {
    return length >= this.getTypeNum().min &&
      this.myform.controls['identityDocument'].valid &&
      !this.loadState
  }

  setInformationFrom(data, loadCustomer, addresses, message) {
    if (data) {
      if (!loadCustomer) {
        this.snackbarService.show('Los datos del cliente han sido encontrados', 'success');
        this.setValueCustomer(data);
      } else {
        this.setValueLoad(loadCustomer, data.addresses.length ? data.addresses : addresses ? addresses : [], data);
      }
      const from = Object.keys(this.myform.value);
      from.forEach(control => {
        this.myform.controls[control].markAsTouched({ onlySelf: true });
      })
    } else {
      if (loadCustomer) {
        this.setValueLoad(loadCustomer, addresses, loadCustomer);
      } else {
        this.clearForm();
        this.snackbarService.show(message, 'warning');
      }
    }
  }

  setValueLoad(loadCustomer, addresses, currentData) {
    this.myform.patchValue({
      name: loadCustomer.name,
      lastName: loadCustomer.documentType === Constants.Customer.DOCUMENT_TYPES.RUC ? '' : (loadCustomer.lastName ? loadCustomer.lastName : '-'),
      phone: loadCustomer.contactPhone ? loadCustomer.contactPhone : '-',
      email: loadCustomer.contactEmail ? loadCustomer.contactEmail : '-',
      addresses: addresses ? addresses : [],
      dataCurrent: JSON.parse(JSON.stringify(currentData)),
      companySalesEnabled: (loadCustomer?.companySalesEnabled !== undefined && loadCustomer?.companySalesEnabled !== null)
        ? loadCustomer.companySalesEnabled
        : (currentData?.companySalesEnabled || false)
    });
    this.setCompanySalesEditable();
  }

  setValueCustomer(data) {
    this.myform.patchValue({
      name: data.name,
      lastName: data.lastName ? data.lastName : '-',
      phone: this.getLastContact(data, 'PHONE'),
      email: this.getLastContact(data, 'EMAIL'),
      addresses: data.addresses ? data.addresses : [],
      dataCurrent: JSON.parse(JSON.stringify(data)),
      companySalesEnabled: data.companySalesEnabled || false
    });
    this.setCompanySalesEditable();
  }

  clearForm() {
    this.isActive = false;
    this.idCustomer = null;
    this.pickPerson = false;
    this.isDeferredPayment = true;
    this.showInputCredits = false;
    this.myform.patchValue(
      {
        name: '',
        lastName: '',
        phone: '',
        email: '',
        nameAditional: '',
        documentAditional: '',
        addresses: [],
        aditional:
        {
          expirationStatus: '-',
          availableCredit: '-',
          availableCreditText: '-',
          customerType: 'NATURAL_PERSON',
          paymentMethod: 'CASH',
          numberOfPayment: '',
          creditOption: '',
          numberInstallments: '',
          numberDeferredInstallments: ''
        }
      }
    );
    if (this.isHESACompany) {
      this.myform.controls['companySalesEnabled'].patchValue(false);
      this.setCompanySalesEditable();
    }
    this.getCustomerData.emit();
    if (this.myform.controls['documentType'].value === 'RUC') {
      this.myform.controls['lastName'].patchValue('-');
    }
  }

  getLastContact(data: Customer, type: string) {
    if (data.contactInfo.length) {
      const email = data.contactInfo
        .filter(item => item.contactType === type)
        .reverse()
        .find(i => i.active);
      return email ? email.contact : '';
    }
  }

  // funcion que define la longitud del campo número de documento
  getTypeNum(typeDocument?: string) {
    const type = typeDocument ? typeDocument : this.myform.controls['documentType'].value;
    let longitud;
    switch (type) {
      case 'DNI':
        if (this.country === Country.PERU) {
          longitud = { min: 8, max: 8 };
        } else {
          longitud = { min: 10, max: 10 };
        }
        break;
      case 'PASSPORT':
        longitud = { min: 9, max: 12 };
        break;
      case 'FOREIGN_DOCUMENT':
        longitud = { min: 9, max: 12 };
        break;
      case 'RUC':
        if (this.country === Country.PERU) {
          longitud = { min: 11, max: 11 };
        } else {
          longitud = { min: 13, max: 13 };
        }
        break;
      case 'OTHER':
        longitud = { min: 6, max: 12 };
    }
    return longitud;
  }
  // funcion que define el patron de validacion para numero de documento
  getPattern(typeDocument) {
    let pattern;
    if (typeDocument === 'DNI' || typeDocument === 'RUC') {
      pattern = '^[0-9\\s]+$';
    } else {
      pattern = '^[A-Za-z0-9\\s]+$';
    }
    return pattern;
  }

  validateInput = event => {
    this.validateService.validateInput(event);
  }

  // funcion para el control de errotxtNumber
  getErrorMessage() {
    return this.myform.controls['identityDocument'].hasError('required')
      ? 'Campo obligatorio'
      : this.myform.controls['identityDocument'].hasError('minlength')
        ? 'Mínimo ' + this.getTypeNum().min + ' dígitos'
        : this.myform.controls['identityDocument'].hasError('maxlength')
          ? 'Máximo ' + this.getTypeNum().max + ' dígitos'
          : this.myform.controls['identityDocument'].hasError('pattern')
            ? 'Dígito inválido'
            : '';
  }

  onSelectedPayment(change) {
    this.selectedPaymentMethod(change).then();
  }

  changeLastNameValidators() {
      this.myform.controls['lastName'].clearValidators();
      this.myform.controls['lastName'].updateValueAndValidity();
  }

  selectedPaymentMethod(change): Promise<any> {
    return new Promise(resolve => {
      const value = change.value;
      if (value !== this.quotation.PAYMENT_TYPES_ENTERPRISE.COLLECTION_ACCOUNT) {
        this.myform.controls['aditional'].get('deferredPayment').disable();
        this.myform.controls['aditional'].patchValue({ deferredPayment: false })
      } else {
        this.myform.controls['aditional'].get('deferredPayment').enable();
      }
      this.showInputCredits = false;
      const numberInstallmentsControl = this.myform.get('aditional').get('numberInstallments') as FormControl;
      numberInstallmentsControl.setValue(null)
      const numberDeferredInstallments = this.myform.get('aditional').get('numberDeferredInstallments') as FormControl;
      numberDeferredInstallments.setValue(null)
      if (value === this.quotation.PAYMENT_TYPES_ENTERPRISE.CREDIT) {
        this.changeLastNameValidators();
        if (this.myform.valid) {
          this.customerService.availableCreditCustomer(this.myform.getRawValue(), '')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
              this.setDirect(response);
              resolve(true);
            }, error => {
              this.snackbarService.show('Problemas con el servicio de créditos disponibles, intente de nuevo', 'warning');
              this.myform.controls['aditional'].patchValue({
                paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
              });
              resolve(true);
            });
        } else {
          this.snackbarService.show('Complete los datos obligatorios del cliente', 'warning');
          this.myform.controls['aditional'].patchValue({
            paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
          });
          resolve(true);
        }
      } else if (value === this.quotation.PAYMENT_TYPES_ENTERPRISE.DIRECT_CREDIT) {
        this.changeLastNameValidators();
        if (this.myform.valid) {
          this.customerService.availableCreditCustomer(this.myform.getRawValue(), '')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
              this.setDirectCredit(response);
              resolve(true);
            }, error => {
              console.error('Error crédito directo:', error);
              this.snackbarService.show('Problemas con el servicio de crédito directo, intente de nuevo', 'warning');
              this.myform.controls['aditional'].patchValue({
                paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
              });
              resolve(true);
            });
        } else {
          this.snackbarService.show('Complete los datos obligatorios del cliente', 'warning');
          this.myform.controls['aditional'].patchValue({
            paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
          });
          resolve(true);
        }
      } else if (value === this.quotation.PAYMENT_TYPES_ENTERPRISE.OH_CARD) { 
        numberDeferredInstallments.setValue(this.optionCreditConfig[0].value);
        numberInstallmentsControl.setValue(this.numberInstallmentsOptions[0].value);
        this.resetCreditInfo()
        this.showInputCredits = true;
      }
      else {
        this.resetCreditInfo()
        resolve(true);
      }
    })
  }

  resetCreditInfo() {
    this.myform.controls['aditional'].patchValue({
    availableCredit: '-',
    availableCreditText: '-',
    expirationStatus: '-'
  });
  }

  setDirect(response) {
    const typeCustomer = response.credit.customerType === '2';
    const nonexistentCustomer = response.credit.customerType === '3';
    const state = response.credit.expirationStatus === 'A';
    if (Number(response.credit.creditAvailable) > 0 && typeCustomer && state) {
      this.myform.controls['aditional'].patchValue({
        availableCreditText: Number(response.credit.creditAvailable),
        availableCredit: response.credit,
        expirationStatus: response.credit.expirationStatus === 'A' ? 'Activo' : 'Inactivo'
      });
      this.snackbarService.show('Cargo el crédito satisfactoriamente', 'success');
    } else {
      const message = `
        <h5 class="text-left me-3">No es posible generar cotización con crédito:</h5>
        <p class="text-left">${!state ? 'Cliente inactivo' : ''}</p>
        <p class="text-left">${!typeCustomer && !nonexistentCustomer ? 'Cliente sin gestión de crédito' : ''}</p>
        <p class="text-left">${nonexistentCustomer ? 'Cliente no registrado en SAP' : ''}</p>
        <p class="text-left">${!Number(response.credit.creditAvailable) ? 'Saldo ' + this.currencyCode + '/ ' +  response.credit.creditAvailable : ''}</p>
      `;
      this.snackbarService.show(message, 'error', { autoClose: false });
      this.myform.controls['aditional'].patchValue({
        paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
      });
    }
  }

  setDirectCredit(response) {
    const isApproved = response?.directCredit?.cupEstado?.toUpperCase() === 'APROBADA' || response?.directCredit?.cupEstado?.toUpperCase() === 'APROBADO';
    if (isApproved) {
      this.myform.controls['aditional'].patchValue({
        availableCreditText: Number(response.directCredit.cupDisponible),
        availableCredit: response.directCredit,
        expirationStatus: 'Activo'
      });
      this.snackbarService.show('Cargó el crédito satisfactoriamente', 'success');
    } else {
      const message = `
        <h5 class="text-left me-3">No es posible generar cotización con crédito directo:</h5>
        <p class="text-left">Estado: ${response?.directCredit?.cupEstado || 'Desconocido'}</p>
        <p class="text-left">${response?.directCredit?.message ? response.directCredit.message : ''}</p>
      `;
      this.snackbarService.show(message, 'warning', { autoClose: false });
      this.myform.controls['aditional'].patchValue({
        paymentMethod: this.quotation.PAYMENT_TYPES_ENTERPRISE.CASH,
      });
      this.resetCreditInfo();
    }
  }

  setPaymentMethod(paymentMethod: string): Promise<boolean> {
    return new Promise(resolve => {
        this.myform.controls['aditional'].patchValue({
          paymentMethod: paymentMethod,
        });
      resolve(true);
    });
  }

  enabledPaymentMethod() {
    this.myform.controls['aditional'].enable();
    this.myform.controls['aditional'].updateValueAndValidity();
  }

  /**
   * Inactiva los controles del formulario
   * @param listForm lista de controles que serán habilitados
   */
  disableForm(listForm?: string[]) {
    this.myform.disable({ onlySelf: false, emitEvent: false });
    if (listForm && listForm.length) {
      listForm.forEach(control => {
        // MEJORAR ENABLED DINAMICO
        this.myform.controls[control].enable({ onlySelf: false, emitEvent: false });
        this.myform.controls[control]['controls']['customerType'].disable();
         this.myform.controls['aditional'].get('paymentMethod').disable();
         this.myform.controls['aditional'].get('deferredPayment').disable();
        if (this.showInputCredits) {
          if (!this.quotationParentNumber) { 
            this.myform.controls['aditional'].get('numberInstallments').disable();
            this.myform.controls['aditional'].get('numberDeferredInstallments').disable();
          }
        }
      });
    }
    this.setCompanySalesEditable();
  }

  enableForm() {
    this.myform.enable({ onlySelf: false, emitEvent: false });
    this.setCompanySalesEditable();
  }

  resetFormCustomer() {
    this.clearForm();
    this.myform.controls['documentType'].patchValue(Constants.Customer.DOCUMENT_TYPES.DNI);
    this.myform.controls['identityDocument'].patchValue('');
    this.myform.markAsPristine({ onlySelf: false });
    this.myform.markAsUntouched();
    this.myform.enable();
    this.myform.controls['aditional'].get('deferredPayment').disable();
    this.setCompanySalesEditable();
  }

  setCompanySalesEditable(editable?: boolean) {
    if (!this.isHESACompany || !this.myform?.controls['companySalesEnabled']) {
      this.myform?.controls['companySalesEnabled']?.disable({ onlySelf: false, emitEvent: false });
      return;
    }
    const isNewCustomer = !this.idCustomer && this.isActive;
    const isAllowed = editable !== undefined ? editable : (this.isClone || isNewCustomer);
    if (isAllowed) {
      this.myform.controls['companySalesEnabled'].enable({ onlySelf: false, emitEvent: false });
    } else {
      this.myform.controls['companySalesEnabled'].disable({ onlySelf: false, emitEvent: false });
    }
  }

}
